import { LitElement, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";

@customElement("sb-layout")
export class SaasBaseLayout extends LitElement {
  @state() private spec: string = "";

  @property({ attribute: false })
  set renderSpec(v: string) {
    this.spec = v;
    this.requestUpdate();
  }

  createRenderRoot() {
    return this; // light DOM
  }

  updated() {
    this.renderDynamicContent();
  }

  private renderDynamicContent() {
    if (!this.spec) return;

    const container = this.shadowRoot || this;
    const contentWrapper = container.querySelector(
      "#dynamic-content",
    ) as HTMLElement;

    if (contentWrapper) {
      contentWrapper.innerHTML = this.spec;

      // Important: Upgrade all custom elements so they get connected properly
      contentWrapper.querySelectorAll("*").forEach((el) => {
        if (el.localName.includes("-") && !customElements.get(el.localName)) {
          // If somehow not registered yet
          console.warn(`Element ${el.localName} not registered`);
        } else {
          customElements.upgrade(el);
        }
      });
    }
  }

  render() {
    return html`
      <sb-form
        custom-id="sb-layout-form"
        @sb-form:success=${this.handleSuccess}
        @sb-form:error=${this.handleError}
      >
        <div class="sb-relative sb-flex sb-overflow-x-hidden">
          <div id="dynamic-content"></div>
        </div>
      </sb-form>
    `;
  }

  private handleSuccess = (e: CustomEvent) => console.log("success", e.detail);
  private handleError = (e: CustomEvent) => console.error("error", e.detail);
}
